// JavaScript Document
/**
 * ScrollIt
 * ScrollIt.js(scroll•it•dot•js) makes it easy to make long, vertically scrolling pages.
 *
 * Latest version: https://github.com/cmpolis/scrollIt.js
 *
 * License <https://github.com/cmpolis/scrollIt.js/blob/master/LICENSE.txt>
 */
(function($) {
    'use strict';

    var pluginName = 'ScrollIt',
        pluginVersion = '1.0.3';

    /*
     * OPTIONS
     */
    var defaults = {
        upKey: 38,
        downKey: 40,
        easing: 'linear',
        scrollTime: 600,
        activeClass: 'active',
        onPageChange: null,
        topOffset : 0
    };

    $.scrollIt = function(options) {

        /*
         * DECLARATIONS
         */
        var settings = $.extend(defaults, options),
            active = 0,
            lastIndex = $('[data-scroll-index]:last').attr('data-scroll-index');

        /*
         * METHODS
         */

        /**
         * navigate
         *
         * sets up navigation animation
         */
        var navigate = function(ndx) {
            if(ndx < 0 || ndx > lastIndex) return;

            var targetTop = $('[data-scroll-index=' + ndx + ']').offset().top + settings.topOffset + 1;
            $('html,body').animate({
                scrollTop: targetTop,
                easing: settings.easing
            }, settings.scrollTime);
        };

        /**
         * doScroll
         *
         * runs navigation() when criteria are met
         */
        var doScroll = function (e) {
            var target = $(e.target).closest("[data-scroll-nav]").attr('data-scroll-nav') ||
            $(e.target).closest("[data-scroll-goto]").attr('data-scroll-goto');
            navigate(parseInt(target));
        };

        /**
         * keyNavigation
         *
         * sets up keyboard navigation behavior
         */
        var keyNavigation = function (e) {
            var key = e.which;
            if($('html,body').is(':animated') && (key == settings.upKey || key == settings.downKey)) {
                return false;
            }
            if(key == settings.upKey && active > 0) {
                navigate(parseInt(active) - 1);
                return false;
            } else if(key == settings.downKey && active < lastIndex) {
                navigate(parseInt(active) + 1);
                return false;
            }
            return true;
        };

        /**
         * updateActive
         *
         * sets the currently active item
         */
        var updateActive = function(ndx) {
            if(settings.onPageChange && ndx && (active != ndx)) settings.onPageChange(ndx);

            active = ndx;
            $('[data-scroll-nav]').removeClass(settings.activeClass);
            $('[data-scroll-nav=' + ndx + ']').addClass(settings.activeClass);
        };

        /**
         * watchActive
         *
         * watches currently active item and updates accordingly
         */
        var watchActive = function() {
            var winTop = $(window).scrollTop();

            var visible = $('[data-scroll-index]').filter(function(ndx, div) {
                return winTop >= $(div).offset().top + settings.topOffset &&
                winTop < $(div).offset().top + (settings.topOffset) + $(div).outerHeight()
            });
            var newActive = visible.first().attr('data-scroll-index');
            updateActive(newActive);
        };

        /*
         * runs methods
         */
        $(window).on('scroll',watchActive).scroll();

        $(window).on('keydown', keyNavigation);

        $('body').on('click','[data-scroll-nav], [data-scroll-goto]', function(e){
            e.preventDefault();
            doScroll(e);
        });

    };
}(jQuery));

function expanders(){
	
}

$(document).ready(function() {

	$('.cc-expander').click(function(){
	  $(this).next().slideToggle();
	  if($('.signs', this).text() == '+'){
	    $('.signs', this).text('-');
	  }
	  else{
	    $('.signs', this).text('+');
	  }
	});

	$('html').click(function() {
		$('.sub-menu').css("visibility","hidden").removeClass('show-nav');
	});

	$('.h-bottom ul, .gallery-filter-list ul').click(function(e){
		e.stopPropagation();
	});

	$('.has-dropdown > .nav-link').click(function(e){
	    e.preventDefault();
	    $(this).parent().siblings('.has-dropdown').children('.sub-menu').removeClass('show-nav')
	    $('.sub-menu').css("visibility", "hidden");
	    var targetMenu = $(this).siblings($('.sub-menu'));
	    if (targetMenu.hasClass('show-nav')) {
	      targetMenu.css("visibility", "hidden").removeClass('show-nav');
	    } else {
	      targetMenu.css("visibility", "visible").addClass('show-nav');
	    }
	});

	/*$('.navbar-nav > .nav-item.has-dropdown > .nav-link').click(function(e){
		e.preventDefault();
		$(this).siblings('.sub-menu').toggleClass('show-nav');
	});*/

	//duration of the top scrolling animation (in ms)
	scroll_top_duration = 700,
	//grab the "back to top" link
	$back_to_top = $('.back-top');

	//smooth scroll to top
	$back_to_top.on('click', function(event){
	  event.preventDefault();
	  $('body,html').animate({
	    scrollTop: 0 ,
	    }, scroll_top_duration
	  );
	});

	// mobile burger js
	$(".navbar .navbar-toggler").click(function () {
		$(this).toggleClass('open');
	});

	// Main Carousel Start
	$('.main-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: false,
		speed: 300,
		fade: true,
		adaptiveHeight: true,
		cssEase: 'ease-in-out',
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 1024,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Main Carousel End

	// Attractive Carousel Start
	$('.attractive-carousel-section').slick({
		dots: false,
		infinite: true,
		//autoplay: true,
		adaptiveHeight: true,
		arrows: true,
		centerMode: true,
		centerPadding: '240px',
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		responsive: [
			{
			breakpoint: 1300,
				settings: {
					centerPadding: '150px',
				}
			},
			{
			breakpoint: 1200,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	// Similar Collections Carousel Start
	$('.similar-collections-section').slick({
		dots: false,
		infinite: true,
		//autoplay: true,
		adaptiveHeight: true,
		arrows: true,
		centerMode: false,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
        responsive: [
              {
              breakpoint: 575,
                  settings: {
                      slidesToShow: 1
                  }
              },
          ]

	});
  
  $('.myThumbs').slick({
		dots: false,
	    vertical: true,
	    slidesToShow: 3,
	    infinite: false,
	    slidesToScroll: 1,
	    verticalSwiping: true,
		nextArrow: '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path id="Path" d="M.119.635a.356.356,0,0,1-.1-.363A.382.382,0,0,1,.293.012.408.408,0,0,1,.665.1L7.88,6.734a.355.355,0,0,1,0,.531L.665,13.894a.408.408,0,0,1-.548,0,.356.356,0,0,1,0-.527L7.045,7Z" transform="translate(0 8) rotate(-90)" fill="#979797"/></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path id="Path" d="M.119.635a.356.356,0,0,1-.1-.363A.382.382,0,0,1,.293.012.408.408,0,0,1,.665.1L7.88,6.734a.355.355,0,0,1,0,.531L.665,13.894a.408.408,0,0,1-.548,0,.356.356,0,0,1,0-.527L7.045,7Z" transform="translate(0 8) rotate(-90)" fill="#979797"/></svg></div>',
		responsive: [
			{
			breakpoint: 1300,
				settings: {
				}
			},
			{
			breakpoint: 1200,
				settings: {
					slidesToShow: 3
				}
			},
			{
			breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
			breakpoint: 767,
				settings: {
					slidesToShow: 3,
					vertical: false
				}
			},
			{
			breakpoint: 576,
				settings: {
					slidesToShow: 4,
					vertical: false
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
  
  $('.suite-slide').slick({
		 dots: false,
    slidesToShow: 2,
    infinite: false,
    slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path id="Path" d="M.119.635a.356.356,0,0,1-.1-.363A.382.382,0,0,1,.293.012.408.408,0,0,1,.665.1L7.88,6.734a.355.355,0,0,1,0,.531L.665,13.894a.408.408,0,0,1-.548,0,.356.356,0,0,1,0-.527L7.045,7Z" transform="translate(0 8) rotate(-90)" fill="#979797"/></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8"><path id="Path" d="M.119.635a.356.356,0,0,1-.1-.363A.382.382,0,0,1,.293.012.408.408,0,0,1,.665.1L7.88,6.734a.355.355,0,0,1,0,.531L.665,13.894a.408.408,0,0,1-.548,0,.356.356,0,0,1,0-.527L7.045,7Z" transform="translate(0 8) rotate(-90)" fill="#979797"/></svg></div>'
	});
	// Attractive Carousel End

	// Video Carousel Start
	// $('.video-carousel-section').slick({
	// 	dots: false,
	// 	infinite: true,
	// 	autoplay: true,
	// 	arrows: false,
	// 	centerMode: true,
	// 	adaptiveHeight: true,
	// 	centerPadding: '180px',
	// 	speed: 300,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	responsive: [
	// 		{
	// 		breakpoint: 1024,
	// 			settings: {
	// 				slidesToShow: 1
	// 			}
	// 		},
	// 		{
	// 		breakpoint: 600,
	// 			settings: {
	// 				slidesToShow: 1
	// 			}
	// 		},
	// 		{
	// 		breakpoint: 480,
	// 			settings: {
	// 				slidesToShow: 1
	// 			}
	// 		}
	// 		// You can unslick at a given breakpoint now by adding:
	// 		// settings: "unslick"
	// 		// instead of a settings object
	// 	]
	// });
	// Video Carousel End

	// As Seen Carousel Start
	$('.as-seen-testimonial-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: true,
		autoplaySpeed: 7000,
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		asNavFor: '.as-seen-logo-carousel',
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
	});

	$('.as-seen-logo-carousel').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: false,
		autoplaySpeed: 7000,
		centerMode: true,
		centerPadding: '20px',
		asNavFor: '.as-seen-testimonial-carousel',
		focusOnSelect: true,
		responsive: [
			{
			breakpoint: 1200,
				settings: {
					slidesToShow: 5
				}
			},
			{
			breakpoint: 992,
				settings: {
					slidesToShow: 5
				}
			},
			{
			breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
			breakpoint: 575,
				settings: {
					slidesToShow: 3
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// As Seen Carousel End

	// Inspiration Carousel Start
	$('.inspiration-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: false,
		speed: 300,
		adaptiveHeight: true,
		centerPadding: '160px',
		centerMode: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 4,
					centerPadding: '120px'
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					centerPadding: '80px'
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					centerPadding: '60px'
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 2,
					centerPadding: '40px'
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Inspiration Carousel End

	// Clients Logo Carousel Start
	$('.clients-logo-carousel').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: true,
		speed: 300,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		responsive: [
			{
			breakpoint: 1200,
				settings: {
					slidesToShow: 5
				}
			},
			{
			breakpoint: 992,
				settings: {
					slidesToShow: 4
				}
			},
			{
			breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
			breakpoint: 575,
				settings: {
					slidesToShow: 2
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Clients Logo Carousel End

	// Design process Carousel Start
	$('.design-process-carousel').slick({
		dots: true,
		infinite: true,
		autoplay: true,
		arrows: false,
		autoplaySpeed: 15000,
		fade: true,
		cssEase: 'ease-in-out',
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
			breakpoint: 1024,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 600,
				settings: {
					slidesToShow: 1
				}
			},
			{
			breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Design process Carousel End

	// Clients Say Carousel Start
	$('.clients-say-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		//adaptiveHeight: true,
		arrows: true,
		autoplaySpeed: 15000,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					centerPadding: '150px',
				}
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Clients Say Carousel End

	// Corporate Gallery Carousel Start
	$('.corporate-gallery-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: false,
		speed: 300,
		adaptiveHeight: true,
		centerPadding: '160px',
		centerMode: true,
		slidesToShow: 5,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 4,
					centerPadding: '120px'
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					centerPadding: '80px'
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					centerPadding: '60px'
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 2,
					centerPadding: '40px'
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Corporate Gallery Carousel End

	// What Client Say Carousel Start
	$(".what-client-say-carousel").slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: true,
		speed: 300,
		fade: true,
		adaptiveHeight: true,
		cssEase: 'ease-in-out',
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
  		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
	});
	// What Client Say Carousel End

	// Our Team Carousel Start
	$('.our-team-carousel').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: true,
		autoplaySpeed: 15000,
		centerPadding: '290px',
		centerMode: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 1,
					centerPadding: '120px'
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					centerPadding: '80px'
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					centerPadding: '60px'
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					centerPadding: '60px'
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Our Team Carousel End

	// Award Carousel Start
	$('.award-carousel').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		infinite: true,
		autoplay: true,
		arrows: true,
		speed: 300,
		nextArrow: '<div class="slick-next slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		prevArrow: '<div class="slick-prev slick-arrow"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="44.236px" height="44.236px" viewBox="0 0 44.236 44.236" style="enable-background:new 0 0 44.236 44.236;" xml:space="preserve"><g><g><path d="M22.118,44.236C9.922,44.236,0,34.314,0,22.118S9.922,0,22.118,0s22.118,9.922,22.118,22.118S34.314,44.236,22.118,44.236z M22.118,1.5C10.75,1.5,1.5,10.749,1.5,22.118c0,11.368,9.25,20.618,20.618,20.618c11.37,0,20.618-9.25,20.618-20.618C42.736,10.749,33.488,1.5,22.118,1.5z"/><path d="M19.341,29.884c-0.192,0-0.384-0.073-0.53-0.22c-0.293-0.292-0.293-0.768,0-1.061l6.796-6.804l-6.796-6.803c-0.292-0.293-0.292-0.769,0-1.061c0.293-0.293,0.768-0.293,1.061,0l7.325,7.333c0.293,0.293,0.293,0.768,0,1.061l-7.325,7.333C19.725,29.811,19.533,29.884,19.341,29.884z"/></g></g></svg></div>',
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 2
				}
			}
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});
	// Award Carousel End

	// Selectric Start
	/*
	$('select').selectric();
	$('.page-template select').selectric({
		disableOnMobile: false
	});
	*/
	// Selectric End

	// ScrollIt Start
	$.scrollIt({
		upKey: 38,             // key code to navigate to the next section
		downKey: 40,           // key code to navigate to the previous section
		easing: 'linear',      // the easing function for animation
		scrollTime: 600,       // how long (in ms) the animation takes
		activeClass: 'active', // class given to the active nav element
		onPageChange: null,    // function(pageIndex) that is called when page is changed
		topOffset: 0           // offste (in px) for fixed top navigation
	});
	// ScrollIt End

	// Appearance List Toggle Start
	$(".appearances-list-section .title a .plus-minus").click(function(e){
		//$(".appearances-list-section .appearances-block").removeClass('active');
		$(this).parent().closest(".appearances-block").toggleClass('active');
		e.preventDefault();
	});
	// Appearance List Toggle End	

	// OFI Browser
	objectFitImages();

	$('.ceci-roles-section .nav-link').click(function(){
		var $elid = $(this).attr('aria-controls');
		$('.ceci-roles-image').hide();
		$('#' + $elid + '-img').show();
	})
});

/* Responsive Tabing Start */
'use strict';

$(document).on('show.bs.tab', '.nav-tabs-responsive [data-toggle="tab"]', function(e) {
	var $target = $(e.target);
	var $tabs = $target.closest('.nav-tabs-responsive');
	var $current = $target.closest('li');
	var $parent = $current.closest('li.dropdown');
	$current = $parent.length > 0 ? $parent : $current;
	var $next = $current.next();
	var $prev = $current.prev();
	var updateDropdownMenu = function($el, position){
	$el
		.find('.dropdown-menu')
		.removeClass('pull-xs-left pull-xs-center pull-xs-right')
		.addClass( 'pull-xs-' + position );
	};

	$tabs.find('>li').removeClass('next prev active');
	$prev.addClass('prev');
	$next.addClass('next');
	$current.prev().removeClass('active');
	$current.next().removeClass('active');
	$current.addClass('active');
	
	updateDropdownMenu( $prev, 'left' );
	updateDropdownMenu( $current, 'center' );
	updateDropdownMenu( $next, 'right' );
});
/* Responsive Tabing End */


//plugin bootstrap minus and plus
//http://jsfiddle.net/laelitenetwork/puJ6G/
$('.btn-number').click(function(e){
    e.preventDefault();
    
    fieldName = $(this).attr('data-field');
    type      = $(this).attr('data-type');
    var input = $("input[name='"+fieldName+"']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
        if(type == 'minus') {
            
            if(currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            } 
            if(parseInt(input.val()) == input.attr('min')) {
                $(this).attr('disabled', true);
            }

        } else if(type == 'plus') {

            if(currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if(parseInt(input.val()) == input.attr('max')) {
                $(this).attr('disabled', true);
            }

        }
    } else {
        input.val(0);
    }
});
$('.input-number').focusin(function(){
   $(this).data('oldValue', $(this).val());
});
$('.input-number').change(function() {
    
    minValue =  parseInt($(this).attr('min'));
    maxValue =  parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());
    
    name = $(this).attr('name');
    if(valueCurrent >= minValue) {
        $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
        alert('Sorry, the minimum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    if(valueCurrent <= maxValue) {
        $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
        alert('Sorry, the maximum value was reached');
        $(this).val($(this).data('oldValue'));
    }
    
});
$(".input-number").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
         // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) || 
         // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
             // let it happen, don't do anything
             return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
});



$(".expand-mobile-nav").click(function(){
    var self = $(this).parent();

    self.toggleClass("grandparents-active");
});

